module.exports = __webpack_public_path__ + "img/upload-cloud.66891e26.svg";